import actions from '../../actions/LargeGroupCustomBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('LargeGroupCustom', actions.show.main, actions.show.reset)
